import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Tabs,
  Tab,
  Box,
  Typography,
} from "@mui/material";
const steps = ["Response", "Action", "API", "Notify"];
const NodeModal = ({ isOpen, onClose, node, onSave }) => {
  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({
    nodeName: node?.data?.label || "",
    description: node?.data?.description || "",
    apiConfig: node?.data?.apiConfig || { method: "GET", url: "" },
    notify: node?.data?.notify || { userNumber: "", template: "" },
  });
  if (!isOpen) return null;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleSave = () => {
    onSave(node.id, formData);
    onClose();
  };
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ fontWeight: 700 }}>Edit Node</DialogTitle>
      <DialogContent dividers>
        <Box mb={2} display="flex" gap={2}>
          <TextField
            label="Node Name"
            name="nodeName"
            value={formData.nodeName}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Trigger Keyword"
            name="triggerKeyword"
            value={formData.triggerKeyword}
            onChange={handleChange}
            fullWidth
          />
        </Box>
        <Tabs value={step} onChange={(e, val) => setStep(val)} variant="fullWidth">
          {steps.map((label, index) => (
            <Tab key={label} label={`${index + 1}. ${label}`} />
          ))}
        </Tabs>
        <Box mt={3}>
          {step === 0 && (
            <TextField
              label="Response"
              name="description"
              value={formData.description}
              onChange={handleChange}
              fullWidth
              multiline
              rows={4}
            />
          )}
          {step === 2 && (
            <Box display="flex" gap={2}>
              <TextField
                label="API Method"
                select
                fullWidth
                value={formData.apiConfig.method}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    apiConfig: { ...prev.apiConfig, method: e.target.value },
                  }))
                }
              >
                <option value="GET">GET</option>
                <option value="POST">POST</option>
              </TextField>
              <TextField
                label="API URL"
                fullWidth
                value={formData.apiConfig.url}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    apiConfig: { ...prev.apiConfig, url: e.target.value },
                  }))
                }
              />
            </Box>
          )}
          {step === 3 && (
            <Box display="flex" flexDirection="column" gap={2}>
              <TextField
                label="User Number"
                fullWidth
                value={formData.notify.userNumber}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    notify: { ...prev.notify, userNumber: e.target.value },
                  }))
                }
              />
              <TextField
                label="Template"
                fullWidth
                value={formData.notify.template}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    notify: { ...prev.notify, template: e.target.value },
                  }))
                }
              />
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        {step > 0 && (
          <Button variant="outlined" onClick={() => setStep(step - 1)}>
            Previous
          </Button>
        )}
        {step < steps.length - 1 ? (
          <Button variant="contained" onClick={() => setStep(step + 1)}>
            Next
          </Button>
        ) : (
          <Button
            variant="contained"
            sx={{ bgcolor: "#25D366" }}
            onClick={handleSave}
          >
            Save
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
export default NodeModal;
